import { render } from "./headerPage.vue?vue&type=template&id=64f45467"
import script from "./headerPage.vue?vue&type=script&lang=js"
export * from "./headerPage.vue?vue&type=script&lang=js"

import "./headerPage.vue?vue&type=style&index=0&id=64f45467&lang=css"

import exportComponent from "/Users/yuviony/vspl/ui/vetaconnect_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__